export default __webpack_public_path__ + "static/media/logo-512x512-yellow.de54a683.svg";